import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IEmployeeFormState } from './employee-form.types';
import {
  IDepartmentData,
  IEmployeeFormSubmissionChecklistData,
  IEmployeeFormSubmissionCommentData,
  IEmployeeFormSubmissionData,
  IFormTemplateData,
  IUserData
} from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IEmployeeFormState = {
  version: 1,
  employeeFormSubmissions: [] as IEmployeeFormSubmissionData[],
  employeeFormDepartments: [] as IDepartmentData[],
  employeeFormChecklists: [] as IEmployeeFormSubmissionChecklistData[],
  comments: [] as IEmployeeFormSubmissionCommentData[],
  lastCreatedCommentId: null,
  checklistAssigneeOptions: [] as IUserData[],
  activities: [],
  mentionableUsers: [],
  count: 0,
  lastPromise: null
};

const namespaced = true;

export const employeeForm: Module<IEmployeeFormState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
